import { SuggestiveDropdownProps } from '@ahc-digital/component-library';
import { LinkFieldValue } from '@sitecore-jss/sitecore-jss-nextjs';
import { C10SuggestiveDropdownListProps } from './C10SuggestiveDropdownList.types';
import { useConditionalRendering } from '@/shared/useConditionalRendering';
import { getDroplink } from '@/shared/param-utils';
import { useI18n } from 'next-localization';

function getFallbackText(
  field: { value?: string } | undefined,
  translationKey: string,
  translate?: (key: string) => string
) {
  return field?.value || translate?.(createKey(translationKey)) || '';
}

function createKey(suffix: string) {
  return `SuggestiveDropdownList-${suffix}`;
}

function mapLinks(values?: LinkFieldValue[]): SuggestiveDropdownProps['links'] {
  if (!values?.length) {
    return [];
  }

  return values.map((linkFieldValue) => {
    return {
      text: linkFieldValue.text ?? '',
      href: linkFieldValue.href ?? '',
      target: linkFieldValue.target ?? '_self',
    };
  });
}

export function CreateSuggestiveDropDownListModel(props?: C10SuggestiveDropdownListProps) {
  const { params } = props ?? {};
  const { renderText, renderRichText, renderLink } = useConditionalRendering();
  const { t } = useI18n() || {};
  const fields = props?.fields?.suggestiveDropdown;

  type t = SuggestiveDropdownProps;

  return {
    headline: renderText(fields?.headline),
    headlineTag: getDroplink<t['headlineTag']>(params?.HeadlineTag, 'p'),
    contentAlignment: getDroplink<t['contentAlignment']>(params?.ContentAlignment, 'left'),
    backgroundColor: getDroplink<t['backgroundColor']>(params?.Background, 'whiteSmoke'),
    supportCopy: renderRichText(fields?.supportCopy),
    cta: renderLink(fields?.cTA, { editable: false }),
    placeholderText: getFallbackText(fields?.placeholderText, 'PlaceholderText', t),
    submitButtonText: getFallbackText(fields?.submitButtonText, 'SubmitButtonText', t),
    labelText: getFallbackText(fields?.labelText, 'LabelText', t),
    links: mapLinks(fields?.listOfLinks?.Links?.value),
  };
}
